<template>   
   <el-container style="height:100%">
        <el-header style="height:7%;padding:0">
            <slot name="panel-top"></slot>   
        </el-header>
        <el-main style="height:93%;padding:0 20px">
            <slot name="panel-main"></slot>
        </el-main>
   </el-container>
</template>

<script>
export default {
    
}
</script>